var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.947 30.0003C106.681 20.8799 99.1069 13.3063 89.986 8.04064C80.8652 2.77503 70.519 0.00292969 59.9874 0.00292969C49.4557 0.00292969 39.1095 2.77503 29.9887 8.04064C20.8678 13.3063 13.2936 20.8799 8.02734 30.0003L11.6273 94.8003L111.947 30.0003Z",
    fill: "url(#paint0_linear_4962_5969)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0204 75L8.04043 30C2.77439 39.121 0.00202002 49.4676 0.00195313 59.9996C0.00188624 70.5317 2.77413 80.8782 8.04005 89.9993C13.306 99.1205 20.88 106.695 30.001 111.961C39.1219 117.227 49.4684 120 60.0004 120L118.8 60L34.0204 75Z",
    fill: "url(#paint1_linear_4962_5969)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.98 75L60 120C70.5311 119.998 80.876 117.224 89.9953 111.956C99.1145 106.689 106.687 99.1149 111.951 89.9941C117.216 80.8734 119.987 70.5277 119.986 59.9966C119.986 49.4656 117.214 39.1202 111.948 30H60L85.98 75Z",
    fill: "url(#paint2_linear_4962_5969)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90C63.9397 90 67.8407 89.224 71.4805 87.7164C75.1203 86.2087 78.4275 83.999 81.2132 81.2132C83.999 78.4275 86.2087 75.1203 87.7164 71.4805C89.224 67.8407 90 63.9397 90 60C90 56.0603 89.224 52.1593 87.7164 48.5195C86.2087 44.8797 83.999 41.5726 81.2132 38.7868C78.4275 36.001 75.1203 33.7913 71.4805 32.2836C67.8407 30.776 63.9397 30 60 30C52.0435 30 44.4129 33.1607 38.7868 38.7868C33.1607 44.4129 30 52.0435 30 60C30 67.9565 33.1607 75.5871 38.7868 81.2132C44.4129 86.8393 52.0435 90 60 90Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0002 83.7602C63.1204 83.7602 66.2101 83.1457 69.0928 81.9516C71.9755 80.7576 74.5948 79.0074 76.8011 76.8011C79.0074 74.5948 80.7576 71.9755 81.9516 69.0928C83.1457 66.2101 83.7602 63.1204 83.7602 60.0002C83.7602 56.88 83.1457 53.7904 81.9516 50.9077C80.7576 48.025 79.0074 45.4057 76.8011 43.1994C74.5948 40.9931 71.9755 39.2429 69.0928 38.0489C66.2101 36.8548 63.1204 36.2402 60.0002 36.2402C53.6987 36.2402 47.6552 38.7435 43.1994 43.1994C38.7435 47.6552 36.2402 53.6987 36.2402 60.0002C36.2402 66.3018 38.7435 72.3452 43.1994 76.8011C47.6552 81.257 53.6987 83.7602 60.0002 83.7602Z",
    fill: "#1A73E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4962_5969",
    x1: 8.03934,
    y1: 37.5003,
    x2: 111.947,
    y2: 37.5003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4962_5969",
    x1: 66.4924,
    y1: 116.244,
    x2: 14.5324,
    y2: 26.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4962_5969",
    x1: 51.24,
    y1: 120,
    x2: 103.2,
    y2: 30.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.ebb7a1d23278096e9e2928a664044a73.svg";
export { ForwardRef as ReactComponent };